import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { SiteDataProvider } from "@/context/SiteData";
import { AdminAuthProvider } from "@/context/AdminAuth";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Mission from "@/pages/Mission";
import Portfolio from "@/pages/Portfolio";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Booking from "@/pages/Booking";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import Policies from "@/pages/Policies";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname.startsWith("/payment");

  useEffect(() => {
    if (bare) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [bare]);

  if (bare) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen bg-ivory text-body">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <SiteDataProvider>
            <ScrollToTop />
            <Shell />
            <Toaster position="top-center" />
          </SiteDataProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
